import { useCallback } from 'react';

import { ItemNutritionInformation } from 'features/menu/components/product-detail/product-nutrition-information/item-nutrition-information';
import { useProductWizardContext } from 'features/menu/components/product-wizard';

import { Box } from 'components/ui';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';
import { getComboSlotDefaultItem } from 'state/unified-menu/utils';

export const ComboNutritionInformation = () => {
  const { slotsSelections, selectedProduct } = useProductWizardContext();
  const { indexedMenu } = useUnifiedMenuContext();

  const getSlotSelections = useCallback(() => {
    if (Object.keys(slotsSelections).length > 1) {
      return Object.values(slotsSelections)
        .map(comboSlot => indexedMenu.find(comboSlot?.itemId!))
        .filter(Boolean) as ILocalizedMenuEntry[];
    }
    // fallback to defaults on Step 1
    return (selectedProduct.options?.defaults || [])
      .map(defaultItemId => getComboSlotDefaultItem(indexedMenu, defaultItemId))
      .filter(Boolean) as ILocalizedMenuEntry[];
  }, [indexedMenu, slotsSelections, selectedProduct]);

  return (
    <Box>
      {getSlotSelections().map(item => (
        <ItemNutritionInformation key={item.id} item={item} />
      ))}
    </Box>
  );
};
